<script>
  import { tick } from 'svelte';
  import { ChevronLeft, ChevronRight } from 'lucide-svelte';
  import * as pdfjs from "pdfjs-dist";
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

  export let pageCount;
  export let path = "";
  export let customThumbnail;

  let showPdf;
  let page = 1;
  let maxPage = 1;
  let pdfCanvas;
  let pdfDoc;
  let canvasContext;

  if (customThumbnail == "") {
    showPdf = true;
  } else {
    showPdf = false;
  }

  function triggerAnalytics(direction) {
    try {
      window.posthog.capture("PDF Page Click", { direction });
    } catch (err) {
      console.log(err);
    }
  }

  function previousPage() {
    if (page <= 1) return;
    page--;
    renderPage(page);
    triggerAnalytics("previous");
  }

  function nextPage() {
    if (page >= maxPage) return;
    page++;
    renderPage(page);
    triggerAnalytics("next");
  }

  async function renderPage(pg) {
    const p = await pdfDoc.getPage(pg);
    const viewport = p.getViewport({ scale: 1 });

    pdfCanvas.width = viewport.width;
    pdfCanvas.height = viewport.height;

    const renderCtx = {
      canvasContext,
      viewport
    };

    await p.render(renderCtx).promise;
  }

  async function loadPdf() {
    await tick(); // wait for DOM updates
    if (!pdfCanvas) return;

    canvasContext = pdfCanvas.getContext("2d");
    console.log("got path: ", path);

    try {
      const pdfData = await fetch(path, {
        redirect: "follow"
      });
      pdfDoc = await pdfjs.getDocument({ data: await pdfData.arrayBuffer() }).promise;
      maxPage = pdfDoc.numPages;
      renderPage(1);
    } catch (e) {
      console.error("Failed to load PDF:", e);
      maxPage = 0;
    }
  }

  $: if (showPdf) {
    loadPdf();
  }
</script>

{#if !showPdf}
  <div class="w-full flex flex-col items-center gap-4">
    <img src={customThumbnail} alt="Preview of the PDF sample" class="max-w-full max-h-[400px]" />
    <button
      class="mt-4 px-6 py-2 bg-blue-300 text-white rounded-2xl hover:bg-blue-500"
      on:click={async () => {
        showPdf = true;
        await loadPdf();
      }}
    >
      Show PDF Sample
    </button>
  </div>
{:else}
  <div class="w-full flex flex-col gap-8 bg-neutral-50">
    <div class="mx-auto bg-neutral-50 px-12 h-[400px] sm:h-[800px]">
      <canvas
        bind:this={pdfCanvas}
        class="rounded-sm mx-auto my-6 shadow max-h-full"
        style="width:100%"
      />
    </div>

    <div class="flex gap-4 mx-auto mb-4 text-neutral-700">
      <div class="w-10 h-10 px-8 py-3  {page - 1 < 1 ? 'bg-orange-50' : 'bg-orange-500'} rounded-md flex justify-center items-center gap-2.5">
        <div class="w-6 h-6 relative">
          <button
            on:click={previousPage}
            disabled={page - 1 < 1}
          >
            <ChevronLeft color={page - 1 < 1 ? "orange" : "white"} />
          </button>
        </div>
      </div>
      <div class="h-10 p-3 rounded-md backdrop-blur-lg flex justify-center items-center gap-2.5">
        <div class="text-blue-900 text-base font-medium leading-6 break-words">
          {page}/{maxPage}{pageCount ? " of " + pageCount : ""}
        </div>
      </div>
      <div class="w-10 h-10 px-8 py-3 {page + 1 > maxPage ? 'bg-orange-50' : 'bg-orange-500'} rounded-md flex justify-center items-center gap-2.5">
        <div class="w-6 h-6 relative">
          <button
            on:click={nextPage}
            disabled={page + 1 > maxPage}
          >
            <ChevronRight color={page + 1 > maxPage ? "orange" : "white"} />
          </button>
        </div>
      </div>
    </div>
  </div>
{/if}
